<template>
  <div class="row">
    <div class="col-md-12">
      <div class="membership">
        <div class="form-horizontal">
          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('name_km') ? 'has-error' : '')"
          >
            <label class="col-sm-3 control-label required">{{ $t('fields.khmerName') }}</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-model="membership.name_km"
                :placeholder="$t('fields.khmerName')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('name_km')"
              >
                {{ validations['name_km'][0] }}
              </span>
            </div>
          </div>

          <div
            :class="'form-group ' + (validations !== null && validations.hasOwnProperty('name_en') ? 'has-error' : '')"
          >
            <label class="col-sm-3 control-label required">{{ $t('fields.englishName') }}</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-model="membership.name_en"
                :placeholder="$t('fields.englishName')"
              >
              <span
                class="label-error"
                v-if="validations !== null && validations.hasOwnProperty('name_en')"
              >
                {{ validations['name_en'][0] }}
              </span>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3 control-label">{{ $t('fields.color') }}</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-model="membership.color"
                :placeholder="$t('fields.color_placeholder')"
              >
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">{{ $t('fields.icon') }}</label>
            <div class="col-sm-9">
              <input
                type="file"
                id="icon"
                ref="icon"
                class="custom-file-input"
                @change="previewFiles"
              >
              <label for="icon">{{ $i18n.locale === "km" ? 'ជ្រើសរើសរូបតំណាង' : 'Choose an icon' }}</label>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-offset-3 col-sm-9">
              <img
                v-if="preview"
                :src="preview"
                class="preview-img"
                alt="Image"
              >
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">
              {{ $t('fields.active') }}
            </label>
            <div class="col-sm-9">
              <input
                type="checkbox"
                value="true"
                v-model="membership.active"
              >
            </div>
          </div>

          <div class="form-group">
            <div class="col-sm-offset-3 col-sm-9">
              <template v-if="editable">
                <button
                  @click="onClickUpdate"
                  class="btn btn-primary margin-right-5 btn-sm btn-update"
                >
                  {{ $t('buttons.update') }}
                </button>
              </template>
              <button
                @click="onClickBack"
                class="btn btn-default btn-sm btn-back"
              >
                {{ $t('buttons.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormMembership',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      membership: {
        id: '',
        name_km: '',
        name_en: '',
        active: true,
        color: '',
        icon: []
      },
      preview: process.env.VUE_APP_API + '/img/default.png',
      uuid: null,
      validations: null
    }
  },
  methods: {
    getMembership () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/membership/get-membership', {
        uuid: this.uuid
      }).then((response) => {
        if (response.data.code === 1) {
          this.membership = response.data.data
          this.preview = process.env.VUE_APP_API + '/' + this.membership.icon
        }
      }).catch((error) => {
        this.onResponseError(error)
      })
    },
    onClickBack () {
      this.$router.push({
        name: 'Membership'
      })
    },
    onClickUpdate () {
      const self = this
      const data = new FormData()
      if (self.membership.id) {
        data.append('id', self.membership.id)
      }
      data.append('name_km', self.membership.name_km)
      data.append('name_en', self.membership.name_en)
      data.append('color', self.membership.color)
      data.append('active', self.membership.active)
      data.append('icon', self.membership.icon)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/membership/store', data)
        .then((response) => {
          if (response.data.code === 1) {
            this.$toastr('success', 'The request was processed', 'Membership')
            this.onClickBack()
          }
          if (response.data.code === 0) {
            this.validations = response.data.message
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
    },
    previewFiles (e) {
      this.membership.icon = e.target.files[0]
      this.preview = URL.createObjectURL(this.membership.icon)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$route.params.hasOwnProperty('uuid')) {
        this.uuid = this.$route.params.uuid
        this.getMembership()
      }
      if (!this.editable) {
        $('input').attr('disabled', 'disabled')
      }
    })
  }
}
</script>

<style scoped>
  .preview-img {
    width: 25%;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 15px;
  }

  [type="file"] {
    border: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute !important;
    white-space: nowrap;
    width: 1px;
  }

  [type="file"] + label {
    background-color: #3b569f;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    padding: 5px 10px;
  }

  [type="file"]:focus + label,
  [type="file"] + label:hover {
    background-color: #2c4077;
  }

  [type="file"]:focus + label {
    outline: 1px dotted #000;
  }

  @media screen and (max-width: 992px) {
    .preview-img {
      width: 45%;
    }
  }

  @media screen and (max-width: 768px) {
    .preview-img {
      width: 35%;
    }
  }

  @media screen and (max-width: 576px) {
    .preview-img {
      width: 40%;
    }
  }

</style>
